import { Typography } from "@mui/material";
import React from "react";
import CustomTimeline, { CustomTimeLineSeparator } from "../Timeline/Timeline";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import resumeData from "../../utils/resumeData";
import "./Profile.css";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineContent from "@mui/lab/TimelineContent";
import CustomButtom from "../Button/Button";
import GetAppIcon from "@mui/icons-material/GetApp";

const CustomTimelineItem = ({ title, text, link }) => (
  <TimelineItem>
    <CustomTimeLineSeparator />
    <TimelineContent className="timeline_content">
      {link ? (
        <Typography className="timelineItem_text">
          <span>{title}:</span>{" "}
          <a href={link} target="_blank" rel="noopener noreferrer">
            {text}
          </a>
        </Typography>
      ) : (
        <Typography className="timelineItem_text">
          <span>{title}:</span> {text}
        </Typography>
      )}
    </TimelineContent>
  </TimelineItem>
);

const Profile = () => {
  return (
    <div className="profile container_shadow">
      <div className="profile_name">
        <Typography className="name">{resumeData.name}</Typography>
        <Typography className="title">{resumeData.title}</Typography>
      </div>

      <figure className="profile_image">
        <img src={require("../../assets/images/displayImage.png")} alt="" />
      </figure>

      <div className="profile_information">
        <CustomTimeline icon={<PersonOutlineOutlinedIcon />}>
          <CustomTimelineItem title="Name" text={resumeData.name} />
          <CustomTimelineItem title="Title" text={resumeData.title} />
          <CustomTimelineItem
            title="Email"
            text={resumeData.email}
            link={`mailto:${resumeData.email}`}
          />

          {Object.keys(resumeData.socials).map((key, idx) => (
            <CustomTimelineItem
              key={idx}
              title={key}
              text={resumeData.socials[key].text}
              link={resumeData.socials[key].link}
            />
          ))}
        </CustomTimeline>

        <div className="button_container" style={{ display: "flex" }}>
          <a
            href={resumeData.resume}
            target={"_blank"}
            rel="noopener noreferrer"
            className="a_nostyles"
          >
            <CustomButtom
              text={"Download CV"}
              icon={<GetAppIcon />}
              sx={{ color: "#000" }}
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Profile;
